import React from "react";

class Footer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};

    }

    render() {
        return (
            <footer className="py-4 bg-dark">
                <div className="container">
                    <p className="m-0 text-center text-white">Copyright &copy; Engineering Guru 2020</p>
                </div>
            </footer>
        );
    }
}

Footer.propTypes = {};

export default Footer;
